module.exports = __webpack_public_path__ + "static/media/4.60f76cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/4.png
// module id = 1630
// module chunks = 0